import { inject, injectable } from 'inversify';
import { MainLayoutDependencyTypes } from '@client/composition/main-layout/main-layout.dependency-types';
import type { CurrentClientUserSelectedClientGamesReloaderService } from '@client/entity/current-client-user/domain/service/current-client-user-selected-client-games-reloader.service';
import type { CurrentClientUserSelectedClientService } from '@client/entity/current-client-user/domain/service/current-client-user-selected-client.service';
import { CurrentClientUserDependencyTypes } from '@client/entity/current-client-user/current-client-user.dependency-types';
import type { MainLayoutService } from '@client/composition/main-layout/domain/service/main-layout.service';
import type { MainLayoutStoreCommand } from '@client/composition/main-layout/domain/store/main-layout.store-command';

@injectable()
export class MainLayoutNavigationRefreshService {
  public constructor(
    @inject(CurrentClientUserDependencyTypes.CurrentClientUserSelectedClientGamesReloaderService)
    private readonly selectedClientGamesReloaderService: CurrentClientUserSelectedClientGamesReloaderService,
    @inject(CurrentClientUserDependencyTypes.CurrentClientUserSelectedClientService)
    private readonly selectedClientService: CurrentClientUserSelectedClientService,
    @inject(MainLayoutDependencyTypes.MainLayoutService)
    private readonly mainLayoutService: MainLayoutService,
    @inject(MainLayoutDependencyTypes.MainLayoutStoreCommand)
    private readonly mainLayoutStoreCommand: MainLayoutStoreCommand,
  ) {}

  public async refresh(): Promise<void> {
    await this.selectedClientGamesReloaderService.reload();

    const selectedClient = this.selectedClientService.getSelectedClient();

    this.mainLayoutStoreCommand.updateMainLayoutUiModel({
      navigationElements: this.mainLayoutService.buildGamesNavigationSections(selectedClient),
    });
  }
}
